import React, { createContext, useState, useEffect } from "react";

const viewportContext = createContext({});

export const ViewportProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [tallScreen, setTallScreen] = useState(false);
  const widthBreakpoint = 1080;

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    // Layout is chosen by available WIDTH, not aspect ratio: a large screen in
    // portrait is still a large screen (design doctrine §responsive). The old
    // `width / height < 1.1` rule served the desktop-portrait case (1080×1920)
    // the compact shell and clipped every nav label — the founding defect.
    setTallScreen(width < widthBreakpoint);
  }, [width]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  /* Now we are dealing with a context instead of a Hook, so instead
     of returning the width and height we store the values in the
     value of the Provider */
  return (
    <viewportContext.Provider value={{ width, height, tallScreen }}>
      {children}
    </viewportContext.Provider>
  );
};

/* Rewrite the "useViewport" hook to pull the width and height values
   out of the context instead of calculating them itself */
const useViewport = () => {
  /* We can use the "useContext" Hook to acccess a context from within
       another Hook, remember, Hooks are composable! */
  const { width, height } = React.useContext(viewportContext);
  return { width, height };
};

export { viewportContext, useViewport };
